import { useState, useEffect } from 'react';
import FrequentlyQuestionService from '../../../services/frequentlyQuestion_service';

const Questions = (props) => {
  const [questions, setQuestions] = useState([]);
  
    const loadQuestions = async () => {
      try {
        props.setLoading(true);
        const questionsData = await FrequentlyQuestionService.getAll()
        if (props.logout(questionsData)) return;
        setQuestions(questionsData || []);
      } catch (e) {
        props.message((e?.message || e), "error");
      } finally {
        props.setLoading(false);
      }
    };
  
    useEffect(() => {loadQuestions()}, []);

    const saveChangeQuestions = async () => {
      props.setLoading(true);
      const lostAccess = await props.losesAccess?.();
      if (lostAccess) {
        props.setLoading(false);
        return;
      }
      const questionsUpdate = questions.filter(q => !q.Id.startsWith('temp'))
      const questionsCreate = questions.filter(q => q.Id.startsWith('temp')).map(({ Id, ...rest }) => rest);
      try {
        const hasUpdates = questionsUpdate.length > 0;
        const hasCreates = questionsCreate.length > 0;
        if (!hasUpdates && !hasCreates) {
          props.message("No hay cambios para guardar", "info");
          return;
        }
        if (hasUpdates) {
          const updates = await FrequentlyQuestionService.updates(questionsUpdate);
          if (props.logout(updates)) return;
        }
        if (hasCreates) {
          const creates = await FrequentlyQuestionService.creates(questionsCreate);
          if (props.logout(creates)) return;
        }
        props.message("Preguntas actualizadas con exito", "success");
      } catch(e) {
        props.message(e?.message || e, "error")
      } finally {      
        await loadQuestions()
      }
    }

    const deleteQuestion = async (id) => {
      const lostAccess = await props.losesAccess?.();
      if (lostAccess) return;
      if (id.startsWith('temp')) {
        setQuestions(prev => prev.filter(q => q.Id !== id));
        props.message("Pregunta eliminada con exito", "success");
        return;
      }
      props.setLoading(true)
      try {
        const deleted = await FrequentlyQuestionService.delete(id);
        if (props.logout(deleted)) return;
        if (deleted) {
          props.message("Pregunta eliminada con exito", "success");
          setQuestions(prev => prev.filter(q => q.Id !== id));
        }
      } catch(e) {
        props.message(e?.message || e, "error")
      } finally {
        props.setLoading(false)
      }    
    }

    const handleAddQuestion = async () => {
      const lostAccess = await props.losesAccess?.();
      if (lostAccess) return;
      setQuestions(prev => [
        ...prev,
        {
          Id: `temp-${Date.now()}`,
          Question: '',
          Answer: ''
        }
      ]);
    };

    return {
      questions,
      setQuestions,
      deleteQuestion,
      handleAddQuestion,
      saveChangeQuestions
    }  
}

export default Questions;
